import React from 'react';
import { gql, useQuery } from '@apollo/client';
import EmailPermissions from './EmailPermissions';
import { captureApolloError } from 'util/apolloError';
import ErrorMessage from 'components/ErrorMessage';
import { ProfileDataQuery, ProfileDataQueryVariables } from 'types/graphql';
import { PrimaryNavigationLayout } from 'components/shared';
import type { PrimaryNavigationLayoutProps } from 'components/shared/PrimaryNavigation/PrimaryNavigationLayout';

const GET_PROFILE_DATA = gql`
  query profileData {
    me {
      consent(name: "mailing_list") {
        decision
      }
    }
  }
`;

type Props = PrimaryNavigationLayoutProps & {
  signedSource: string;
};

const PrivacyAndPermissions = ({
  signedSource,
  reviewer,
  header,
  subHeader,
}: Props) => {
  const { data, error, loading } = useQuery<
    ProfileDataQuery,
    ProfileDataQueryVariables
  >(GET_PROFILE_DATA);

  if (loading) return <div className="loading">&nbsp;</div>;
  if (error) {
    captureApolloError(error);
    return <ErrorMessage>Error loading data</ErrorMessage>;
  }

  const consented = data?.me?.consent?.decision === 'CONSENTED';

  return (
    <>
      <PrimaryNavigationLayout
        logoPath="/reviews"
        reviewer={reviewer}
        header={header}
        subHeader={subHeader}
      />
      <EmailPermissions
        mailingListConsent={consented}
        signedSource={signedSource}
      />
    </>
  );
};

export default PrivacyAndPermissions;
